// Third party
import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { reducers } from './reducers';
// TODO add categories
// Data
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';
// Types
import { IRootState } from './types';

const initialState: IRootState = {
  locations: [],
  categories: [],
  productTypes: [],
  collections: [],
  tags: [],
  vendors: [],
  selectedLocationId: null,
  inventoryItems: {},
  isProductsLoading: false,
  currentWorker: null,
  selectedVariant:null,
  isTransferWindowOpen:false
};

export const slice = createSlice({
  name: STORE_SLICES.INVENTORY,
  initialState,
  reducers,
});

const inventoryActions = slice.actions;

const inventoryPersistConfig = {
  key: PERSIST_KEYS.INVENTORY,
  storage,
  whitelist:['categories','productTypes']
};

export {
  inventoryActions,
};
export default persistReducer(inventoryPersistConfig, slice.reducer);
